import {ApiResponse, DscrCalculatorInput, DscrCalculatorValue} from "@portal-workspace/grow-shared-library";
import {Observable} from "rxjs";

export type GetDscrCalculatorValueFn =  (applicationId: number) => Observable<DscrCalculatorValue>;
export type UpdateDscrCalculatorValueFn = (applicationId: number, v: DscrCalculatorInput) => Observable<ApiResponse>;
